import {
  Checkbox,
  DefaultButton,
  Link,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PanelButtons = ({
  showSpinner,
  onPrimaryClick,
  onSecondaryClick,
  disablePrimaryButton,
  disableTermsAndConditions,
  isConditionsApproved,
  setIsConditionsApproved,
  onShowConditions,
}) => {
  const { t: translator } = useTranslation();

  const onRenderCheckboxLabel = () => (
    <Link onClick={onShowConditions} styles={linkStyles}>
      {translator('pages.hearingDetails.conditionsAccept')}
    </Link>
  );

  return (
    <div className="panel-buttons-container">
      <div>
        {!disableTermsAndConditions && (
          <Checkbox
            styles={conditionsCheckboxStyles}
            onChange={(_, value) => setIsConditionsApproved(value)}
            checked={isConditionsApproved}
            onRenderLabel={onRenderCheckboxLabel}
          />
        )}
      </div>
      <div className="panel-buttons">
        {showSpinner && <Spinner size={SpinnerSize.large} />}
        <DefaultButton
          text={translator('global.cancel')}
          onClick={onSecondaryClick}
          disabled={showSpinner}
        />
        <PrimaryButton
          text={translator('global.confirm')}
          disabled={showSpinner || disablePrimaryButton}
          onClick={onPrimaryClick}
        />
      </div>
    </div>
  );
};

export { PanelButtons };

const conditionsCheckboxStyles = {
  root: {
    paddingLeft: '0px',
    label: {
      '.ms-Checkbox-checkbox': {
        width: '30px',
        height: '30px',
      },
    },
  },
  label: {
    alignItems: 'center',
  },
};

const linkStyles = {
  root: {
    marginLeft: '4px',
  },
};
